import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Image, Container } from 'react-bootstrap';
import $ from 'jquery';

import * as Common from '../mc/Common';
import Dialog from '../mc/Dialog';

import '../mcss/loginv1.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';


let imgLogo = {
    height: '100px'
}

function Loginv1() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [isSignIn, setIsSignIn] = useState(true);
    const [isForget, setIsForget] = useState(false);
    const [userId, setUserId] = useState("");
    const [userPass, setUserPass] = useState("");
    const [userEmail, setEmail] = useState("");

    sessionStorage.clear();

    function onClickForget() {
        setIsSignIn(false);
        setIsForget(true);
    }

    function onClickGoBack() {
        setIsForget(false);
        setIsSignIn(true);
    }

    function onClickSignIn() {
        $('.loader').show();
        sessionStorage.clear();
        if (userId === "" || userPass === "") {
            $('.loader').hide();
            setMsgText(Common.getMessage("MSG0001"));
            setMsgBox(true);
        } else {
            Common.callApi(Common.apiLogin, ['validate', userId, userPass, Common.appName, 0, 33], function (result) {
                $('.loader').hide();
                let resp = JSON.parse(result);
                //console.log(result);
                if (resp.status === "MSG0000") {
                    sessionStorage.sessionId = resp.session;
                    sessionStorage.userName = resp.name;
                    sessionStorage.userSrno = resp.srno;
                    sessionStorage.entityId = resp.entityid;
                    sessionStorage.entityType = resp.entitytype;
                    sessionStorage.entityname = resp.entityname;
                    sessionStorage.myInterval = "";
                    sessionStorage.nocoverviewagent = resp.nocoverviewagent;
                    sessionStorage.disableCommissionChange = resp.disableCommissionChange;
                    // console.log('Inside Sign In ', resp.chg_pw_on_logon);
                    if (resp.chg_pw_on_logon === "0" || resp.chg_pw_on_logon === 0) {
                        sessionStorage.chngPassOnLogin = 0;
                        if (resp.rightNew === "1") {
                            //       console.log('Inside right new request ');
                            navigate("/new-request");
                        } else if (resp.rightInPro === "1") {
                            console.log('Inside right In Pro ');
                            navigate("/in-progress");
                        } else if (resp.rightEnquiryList === "1") {
                            console.log('Inside right Enquiry Status ');
                            navigate("/enquiry-status");
                        } else if (resp.rightInwardList === "1") {
                            console.log('Inside right Inwardlist Status ');
                            navigate("/inwardlist");
                        }
                    } else if (resp.chg_pw_on_logon === "1" || resp.chg_pw_on_logon === 1) {
                        sessionStorage.chngPassOnLogin = 1;
                        navigate("/changepassword", { state: { login: true } });
                    } else {
                        setMsgText(Common.getMessage("ERR0000"));
                        setMsgBox(true);
                    }
                } else {
                    setMsgText(Common.getMessage(resp.status));
                    setMsgBox(true);
                }
            });
        }
    }

    function onClickReset() {
        $('.loader').show();
        if (userId === "" || userEmail === "") {
            $('.loader').hide();
            setMsgText("Invalid User Id or Email Id.");
            setMsgBox(true);
        } else {
            Common.callApi(Common.apiLogin, ['reset', userId, userEmail], function (result) {
                $('.loader').hide();
                let resp = JSON.parse(result);
                setMsgText(resp.msg);
                setMsgBox(true);
                onClickGoBack();
            });
        }
    }

    return (
        <>
            <Container>

                <div className="row">
                    <div className='col'>
                        &nbsp;
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-12 align-middle" style={{ height: '100vh' }} >
                        <div className="wrap d-md-flex">
                            <div className="login-wrap">
                                <Image src="img/service1.jpg" fluid />
                            </div>
                            <div className="login-wrap p-4 p-md-5">
                                <div className="row justify-content-center">
                                    <div className="col" align="center">
                                        <Image style={imgLogo} src="img/zenith-e-remit.png" fluid />
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="w-100">
                                        <h3 className="mb-4">
                                            {isSignIn ? "Sign In"
                                                : "Reset Password"
                                            }
                                        </h3>
                                    </div>
                                    <div className="w-100">
                                        <p className="social-media d-flex justify-content-end">
                                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/zenithfinserv/" className="social-icon d-flex align-items-center justify-content-center"><FontAwesomeIcon icon={faFacebook} /></a>
                                            <a target="_blank" rel="noreferrer" href="https://twitter.com/ZenithFinserv" className="social-icon d-flex align-items-center justify-content-center"><FontAwesomeIcon icon={faTwitter} /></a>
                                            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/zenithfinserv/" className="social-icon d-flex align-items-center justify-content-center"><FontAwesomeIcon icon={faInstagram} /></a>
                                            {
                                                /*
                                                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/14636373/admin/" className="social-icon d-flex align-items-center justify-content-center"><FontAwesomeIcon icon={faLinkedin} /></a>
                                                */
                                            }
                                        </p>
                                    </div>
                                </div>
                                <form className="signin-form">
                                    <div className="form-group mb-3">
                                        <label className="label text-uppercase mb-1" >Username</label>
                                        <input type="text" className="form-control form-control-lg" placeholder="Username" required=""
                                            maxLength="20"
                                            value={userId}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value.trim(), setUserId)} autoComplete="off"
                                        ></input>
                                    </div>
                                    {
                                        isSignIn ?
                                            <>
                                                <div className="form-group mb-3">
                                                    <label className="label text-uppercase mb-1" >Password</label>
                                                    <input type="password" className="form-control form-control-lg" placeholder="Password" required=""
                                                        maxLength="20"
                                                        value={userPass}
                                                        onChange={(e) => Common.validateAlpNumSplValue(e.target.value.trim(), setUserPass)} autoComplete="off"
                                                    ></input>
                                                </div>
                                                <div className="form-group pt-2">


                                                    <button type="button" className="form-control btn btn-lg btn-primary rounded px-3"
                                                        onClick={(e) => onClickSignIn()}>
                                                        Sign In
                                                    </button>
                                                </div>
                                            </>
                                            : null
                                    }
                                    {
                                        isForget ?
                                            <>
                                                <div className="form-group mb-3">
                                                    <label className="label text-uppercase mb-1" >Email Id</label>
                                                    <input type="email" className="form-control form-control-lg" placeholder="Email" required=""
                                                        onChange={(e) => setEmail(e.target.value.trim())} autoComplete="off"
                                                        onBlur={(e) => Common.validtateEmail(e.target.value.trim(), setEmail)}
                                                    ></input>
                                                </div>
                                                <div className="form-group pt-2">
                                                    <button type="button" className="form-control btn btn-lg btn-primary rounded px-3" onClick={(e) => onClickReset()} >Reset</button>&nbsp;
                                                    <button type="button" className="form-control btn btn-lg btn-primary rounded px-3" onClick={(e) => onClickGoBack()} >Back</button>
                                                </div>

                                            </>
                                            : null
                                    }
                                    {
                                        isSignIn ?
                                            <div className="form-group d-flex my-3">
                                                <div className="w-50 text-start">
                                                </div>
                                                <div className="w-50 text-end">
                                                    <span onClick={onClickForget} className="handCursor colorBlue" >Forgot Password</span>
                                                </div>
                                            </div>
                                            : null}
                                </form>
                                <div className="row justify-content-center">
                                    <div className="col" align="center">
                                        <FontAwesomeIcon icon={faEnvelope} />&nbsp;support@zenithforex.com&nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faMobileAlt} />&nbsp;98705&nbsp;66055
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Container >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    )
}
export default Loginv1;